"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _staticContent = require("../staticContent");
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SubmitSpinner = props => {
  var {
    locale = _constants.CONTENTFUL_LOCALE.enCA,
    language = _constants.CONTENTFUL_LOCALE.en
  } = props;
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.Spinner, {
    show: true,
    label: locale ? _staticContent.FORM_COMPONENT.SPINNER_MESSAGE[language] : _staticContent.FORM_COMPONENT.SPINNER_MESSAGE.en
  });
};
SubmitSpinner.propTypes = {
  locale: _propTypes.default.string,
  language: _propTypes.default.string
};
var _default = exports.default = SubmitSpinner;